import { isJest } from "./isJest";
class ResizeObserverMock {
    observe() {
        // do nothing
    }
    unobserve() {
        // do nothing
    }
    disconnect() {
        // do nothing
    }
}
export const ResizeObserver = isJest() ? ResizeObserverMock : window.ResizeObserver;
//# sourceMappingURL=ResizeObserver.js.map